export default "__VITE_ASSET__ffc2784c__"